import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "selectAllButton", "checkbox"]
  static values = {
    attributeName: String,
    selectAll: String,
    deselectAll: String
  }

  connect() {
    this.updateSelectAllButtonState()
  }

  selectAll() {
    const checkboxes = this.checkboxTargets.filter(checkbox => 
      checkbox.closest(`[data-collection-checkboxes-attribute-name-value="${this.attributeNameValue}"]`)
    )
    
    const allChecked = checkboxes.every(checkbox => checkbox.checked)
    checkboxes.forEach(checkbox => checkbox.checked = !allChecked)
    this.updateSelectAllButtonState()
  }

  updateSelectAllButtonState() {
    const checkboxes = this.checkboxTargets.filter(checkbox => 
      checkbox.closest(`[data-collection-checkboxes-attribute-name-value="${this.attributeNameValue}"]`)
    )
    
    const allChecked = checkboxes.every(checkbox => checkbox.checked)
    this.selectAllButtonTarget.textContent = allChecked ? this.deselectAllValue : this.selectAllValue
  }
} 